import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule,ReactiveFormsModule }   from '@angular/forms';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { registerLocaleData } from '@angular/common';
import localDe from '@angular/common/locales/de';

import { AppComponent } from './app.component';
import { VideosComponent } from './videos/videos.component';
import { MenuComponent } from './menu/menu.component';
import { VideoDetailComponent } from './video-detail/video-detail.component';
import { NoMenuComponent } from './no-menu/no-menu.component';
import { LoginComponent } from './guest/login/login.component';
import { LoginPageComponent } from './guest/login-page/login-page.component';
import { RegisterComponent } from './guest/register/register.component';
import { ErrorMessagesComponent } from './validation/error-messages/error-messages';

import { PaypalService } from './services/paypal.service';
import { UserService } from './services/user.service';
import { VideoService } from './services/video.service';

import { ValidationService } from './validation/register.validation';

import { AuthGuard } from './guards/auth.guard';

import { AppRoutingModule } from './app-routing.module';

import { PopoverModule } from 'ngx-bootstrap/popover';
import { ExerciseContentComponent } from './exercise-content/exercise-content.component';
import { PasswordResetComponent } from './guest/password-reset/password-reset.component';
import { NewPasswordComponent } from './guest/new-password/new-password.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NoMenuDashboardComponent } from './no-menu-dashboard/no-menu-dashboard.component';
import { SettingsComponent } from './settings/settings.component';

registerLocaleData(localDe);

@NgModule({
  declarations: [
    AppComponent,
    VideosComponent,
    LoginComponent,
    LoginPageComponent,
    MenuComponent,
    VideoDetailComponent,
    NoMenuComponent,
    RegisterComponent,
    ErrorMessagesComponent,
    ExerciseContentComponent,
    PasswordResetComponent,
    NewPasswordComponent,
    DashboardComponent,
    NoMenuDashboardComponent,
    SettingsComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule ,
    AngularFontAwesomeModule,
    PopoverModule.forRoot()
  ],
  providers: [
    PaypalService,
    UserService,
    AuthGuard,
    VideoService,
    ValidationService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts